import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthComponentsModule } from '../../components';
import { FormForLinkRewardsAccountPasswordModule } from '@shared/core/modules/forms/formTypes/forLinkRewardsAccountPassword';

import { AuthForRewardsAccountLinkingComponent } from './auth-for-rewards-account-linking-password.shared.component';


@NgModule({
    declarations: [
        AuthForRewardsAccountLinkingComponent
    ],
    imports: [
        CommonModule,
        AuthComponentsModule,
        FormForLinkRewardsAccountPasswordModule,
    ],
    exports: [
        AuthForRewardsAccountLinkingComponent
    ]
})
export class AuthForRewardsAccountLinkingPasswordModule { }
